import React, { Suspense } from 'react'
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom'
import { CSpinner } from '@coreui/react'
import './scss/style.scss'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min'

// custom css
import "./css/datatable.css";
import "./css/form.css";
import "./css/mobile-views.css";

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const LandingPage = React.lazy(() => import('./views/__auth/login/LandingPage'))
const Logout = React.lazy(() => import('./views/__auth/logout/Logout'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))
const Graph_Sens_SoilTRH = React.lazy(() => import('./views/__farmiTec/deviceCore/Graph_Sens_SoilTRH'))
const Graph_Sens_AirTRH = React.lazy(() => import('./views/__farmiTec/deviceCore/Graph_Sens_AirTRH'))
const Graph_IrriOnly_Manual = React.lazy(() => import('./views/__farmiTec/deviceCore/Graph_IrriOnly_Manual'))
const Graph_Sens_Ferti = React.lazy(() => import('./views/__farmiTec/deviceCore/Graph_Sens_Ferti'))

const App = () => {
  return (
    <Router>
      <Suspense
        fallback={
          <div className="pt-3 text-center">
            <CSpinner color="primary" variant="grow" />
          </div>
        }
      >
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/404" element={<Page404 />} />
          <Route path="/500" element={<Page500 />} />
          {/* Standalone graph page without CoreUI layout */}
          <Route path="/graph/sens-soiltrh" element={<Graph_Sens_SoilTRH />} />
          <Route path="/graph/sens-airtrh" element={<Graph_Sens_AirTRH />} />
          <Route path="/graph/irri-manual" element={<Graph_IrriOnly_Manual />} />
          <Route path="/graph/sens-ferti" element={<Graph_Sens_Ferti />} />
          <Route path="/*" element={<DefaultLayout />} />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
      </Suspense>
    </Router>
  )
}

export default App
